import { Grid } from "@mui/material";
import { useMemo, useState } from "react";
import MaskMultiSelect from "./MaskMultiSelect";
import MaskMultiSelectScroll from "./MaskMultiSelectScroll";
import Text from "./Text";
import { INTAKE_FORM_SECTIONS } from "../pages/app/provider/scheduling/appointment/appointment-constant";
import {
  DEF_PAGINATION,
  DGT_Pagination,
  getXtenantId,
  replaceUnderScoreAddSpace,
} from "../utils/utils";
import { useGetAllScreenerType } from "../queries/patient-chart/assessment/assement-forms/use-get-all-screener-type";
import { useDebounce } from "../hooks/use-debounce";

interface IntakeFormsProps {
  assessments: any;
  setAssessments: any;
  selectedIntakeForms: any;
  setSelectedIntakeForms: any;
}

const IntakeForms = ({
  assessments,
  setAssessments,
  selectedIntakeForms,
  setSelectedIntakeForms,
}: IntakeFormsProps) => {
  const [searchAssessmentString, setSearchAssessmentString] =
    useDebounce<string>("");
  const [assessmentPagination, setAssessmentPagination] =
    useState<DGT_Pagination>(DEF_PAGINATION);
  const { data: assessmentList, isFetching: isAssessmentFetching } =
    useGetAllScreenerType({
      pagination: assessmentPagination,
      xTENANTID: getXtenantId(),
      searchString: searchAssessmentString,
    });

  const assessmentOptions = useMemo(() => {
    const fetched =
      assessmentList?.data?.content?.map((item: any) => ({
        value: item,
        label: replaceUnderScoreAddSpace(item),
      })) ?? [];
    const selected = (assessments ?? []) as { value: string; label: string }[];
    const missing = selected.filter(
      (s) => !fetched.some((o: { value: string }) => o.value === s.value)
    );
    return [...missing, ...fetched];
  }, [assessmentList, assessments]);

  return (
    <Grid container spacing={2} mt={1}>
      <Grid item xs={6} container>
        <Grid item xs={12}>
          <MaskMultiSelect
            label="Intake Forms"
            options={INTAKE_FORM_SECTIONS}
            optionWithCheckbox={true}
            placeholder="Search and Select Forms"
            value={selectedIntakeForms}
            onChange={(values) => {
              setSelectedIntakeForms(values);
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <ul
            style={{
              listStyleType: "square",
            }}
          >
            {(selectedIntakeForms ?? [])?.map((f: any) => (
              <li key={f?.value}>
                <Text color={"grey"}>{f?.label}</Text>
              </li>
            ))}
          </ul>
        </Grid>
      </Grid>

      <Grid item xs={6} container>
        <Grid item xs={12}>
          <MaskMultiSelectScroll
            label="Assessments"
            onSearch={(value) => setSearchAssessmentString(value)}
            options={assessmentOptions}
            optionWithCheckbox={true}
            placeholder="Search and Select Forms"
            value={assessments}
            onChange={(values) => setAssessments(values)}
            pagination={assessmentPagination}
            setPagination={setAssessmentPagination}
            totalElements={assessmentList?.data?.page?.totalElements}
            loading={isAssessmentFetching}
          />
        </Grid>
        <Grid item xs={12}>
          <ul
            style={{
              listStyleType: "square",
            }}
          >
            {((assessments as any) ?? [])?.map((f: any) => (
              <li key={f?.value}>
                <Text color={"grey"}>{f?.label}</Text>
              </li>
            ))}
          </ul>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default IntakeForms;
